import React from 'react'
import PropTypes from 'prop-types'
import { Marker, Circle } from '@react-google-maps/api'

const GeofenceMarker = props => {
  const { onMarkerDragEnd, markerPosition, geofenceName, radius, draggable } = props
  const rad = Number(radius) || 0
  const options = {
    fillColor: 'yellow',
    fillOpacity: 0.5,
    strokeWeight: 2,
  }
  return (
    <>
      <Marker draggable={draggable} onDragEnd={onMarkerDragEnd} position={markerPosition} title={geofenceName} />
      <Circle center={markerPosition} radius={rad} options={options} />
    </>
  )
}

GeofenceMarker.propTypes = {
  onMarkerDragEnd: PropTypes.func,
  markerPosition: PropTypes.shape({ lat: PropTypes.number, lng: PropTypes.number }),
  geofenceName: PropTypes.string,
  radius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  draggable: PropTypes.bool,
}

export default GeofenceMarker
